import { Trash2, RefreshCw } from 'lucide-react'

import { useTranslation } from '@/core/i18n/useTranslation'
import { Button } from '@/shared/components/atoms/Button'

interface DeleteSectionProps {
	deleteText: string
	onDelete: () => void
	refreshText?: string
	onRefresh?: () => void
}

export const DeleteSection: React.FC<DeleteSectionProps> = ({
	deleteText,
	onDelete,
	refreshText,
	onRefresh,
}) => {
	const { t } = useTranslation('zones')

	return (
		<div className="border rounded-lg p-5 bg-card-dark">
			<div className="flex items-center justify-between">
				<h2 className="text-base font-semibold">
					{t('details.deleteSection.dangerZone')}
				</h2>
				<div className="flex items-center gap-2">
					{onRefresh && refreshText && (
						<Button
							variant="outline"
							className="rounded-full bg-shade border text-xs font-semibold hover:bg-shade/80"
							onClick={onRefresh}
						>
							{refreshText}
							<RefreshCw className="h-3 w-3" />
						</Button>
					)}
					<Button
						variant="destructive"
						className="rounded-full bg-shade text-red-400 border text-xs font-semibold hover:bg-shade/20"
						onClick={onDelete}
					>
						{deleteText}
						<Trash2 className="h-3 w-3" />
					</Button>
				</div>
			</div>
		</div>
	)
}
